// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "common/src/data/Data.bs.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as ReactDnd from "react-dnd";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";

function TbItemCell(Props) {
  var sizeOpt = Props.size;
  var search = Props.search;
  var itemId = Props.itemId;
  var size = sizeOpt !== undefined ? sizeOpt : 32;
  var itemsT = Translation.useT(/* Items */3);
  React.useContext(TftSet.ctx);
  var setNum = TftSet.use(undefined);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var match$1 = ReactDnd.useDrag({
        type: "item",
        item: {
          id: itemId,
          type: "item",
          itemId: itemId
        }
      });
  var item = Data.itemInfo(itemId, setNum);
  var searchMatch = search === "" || Belt_Option.mapWithDefault(item, false, (function (item) {
          if (item.name.toLowerCase().includes(search.toLowerCase())) {
            return true;
          } else {
            return itemsT(itemId).toLowerCase().includes(search.toLowerCase());
          }
        }));
  return React.createElement(ItemTooltip.make, {
              itemId: itemId,
              children: React.createElement("div", {
                    ref: match$1[1],
                    className: "cursor-pointer transition-opacity " + (
                      searchMatch ? "" : "opacity-30"
                    ),
                    onDragStart: (function (e) {
                        return e.preventDefault();
                      })
                  }, React.createElement(ItemImage.make, {
                        itemId: itemId,
                        size: size
                      })),
              disabled: match[0]
            });
}

var make = TbItemCell;

export {
  make ,
  
}
/* Data Not a pure module */
